import { $api } from "@/lib/api";
import { useAuth } from "@/hooks/useAuth";

/**
 * Lazy-load full meeting intelligence detail (including transcript text)
 * for a single meeting. Only fetches when meetingId is provided.
 */
export function useMeetingDetail(meetingId: string | null) {
  const { backendToken } = useAuth();
  return $api.useQuery(
    "get",
    "/api/v1/meetings/{meeting_id}/intelligence",
    { params: { path: { meeting_id: meetingId! } } },
    { staleTime: 5 * 60 * 1000, enabled: !!meetingId && !!backendToken },
  );
}
